/**
 * Contact page
 */

import axios from 'axios';
import ContactNumbers from '@siteminder/studio-contact-api'
import pageLang from '../util/pageLang.js'
import ArrayFrom from 'array-from'

export default {
  init() {
    class Contact {
      constructor(translations) {
        this.translations = translations

        // slow as this is a promise, it needs the others init first
        this.endpointGeo = 'https://resources.siteminder.com/services/geo/index.php'
        this.request()
      }

      request() {
        axios.get(this.endpointGeo)
          .then((response) => {
            console.log(response)
            const lang = pageLang

            this.fetchAll(lang)

          })
          .catch((e) => {
            console.warn('GeoIP API error. Defaulting request.', e)
            this.country = 'us'
            this.region = 'amer'
          })
      }

      fetchAll(lang) {
        const $contactNumbers = new ContactNumbers()
        const tabs = ArrayFrom(document.querySelectorAll('.support-numbers'))
        tabs.forEach((tab) => {
          const supportRegion = tab.getAttribute('data-region').toUpperCase()
          const productSupport = tab.querySelector('.contacts-product-support')
          const salesSupport = tab.querySelector('.contacts-sales-support')

          return $contactNumbers.ready({
            lang: lang,

          }).then((contactNumbers) => {
            const list = []
            let markup = ''
            contactNumbers.forEach((contactNumber) => {
              const region = contactNumber.region[0]
              const hours = this.getHours(contactNumber.availabilitySummary)
              const toll = this.getToll(contactNumber.tollFree)

              if (contactNumber.brand == 'LH') {
                if (region === supportRegion && supportRegion !== 'GBAF') { // Exclude South Africa
                  list.push(`<li class="pt-0">${contactNumber.name} ${toll}: ${contactNumber.number} ${hours}</li>`)

                  if (contactNumber.service[1] !== undefined && contactNumber.service[1] === 'sales') {
                    markup += `<li class="pt-0">${contactNumber.name} ${toll}: ${contactNumber.number}</li>`
                  }
                } else {
                  // South Africa
                  if (supportRegion === 'GBAF' && contactNumber.country[0] === 'ZA') {
                    if (contactNumber.country[0] === 'ZA') {
                      list.push(`<li class="pt-0">${contactNumber.name} ${toll}: ${contactNumber.number} ${hours}</li>`)
                      markup += `<li class="pt-0">${contactNumber.name} ${toll}: ${contactNumber.number}</li>`
                    }
                  }
                }
              }
            })
            salesSupport.innerHTML = markup
            productSupport.innerHTML = list.join('')
          })
        })
      }

      // Get support hours + timezones
      getHours(availabilitySummary) {
        if (availabilitySummary.length > 0) {
          return `<span>| ${availabilitySummary[0].opens} - ${availabilitySummary[0].closes}<span class="fine-copy"> (${availabilitySummary[0].timezone})</span></span>`
        } else {
          return `<span>| ${this.translations.support}</span>`
        }
      }

      // Toll free
      getToll(tollFree) {
        if (tollFree) {
          return `<span>${this.translations.tollFree}</span>`
        } else {
          return ''
        }
      }
    }

    const translations = window.contactTranslations
    new Contact(translations)
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js